export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5316.7fa98a21.jpg";